/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_Move_UpInputs */

const en_admin_questionnaire_editor_move_up = /** @type {(inputs: Admin_Questionnaire_Editor_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move up`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_Move_UpInputs) => LocalizedString} */
const de_admin_questionnaire_editor_move_up = en_admin_questionnaire_editor_move_up;

/** @type {(inputs: Admin_Questionnaire_Editor_Move_UpInputs) => LocalizedString} */
const es_admin_questionnaire_editor_move_up = en_admin_questionnaire_editor_move_up;

/** @type {(inputs: Admin_Questionnaire_Editor_Move_UpInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_move_up = en_admin_questionnaire_editor_move_up;

/** @type {(inputs: Admin_Questionnaire_Editor_Move_UpInputs) => LocalizedString} */
const it_admin_questionnaire_editor_move_up = en_admin_questionnaire_editor_move_up;

/** @type {(inputs: Admin_Questionnaire_Editor_Move_UpInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_move_up = en_admin_questionnaire_editor_move_up;

/** @type {(inputs: Admin_Questionnaire_Editor_Move_UpInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_move_up = en_admin_questionnaire_editor_move_up;

/** @type {(inputs: Admin_Questionnaire_Editor_Move_UpInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_move_up = en_admin_questionnaire_editor_move_up;

/** @type {(inputs: Admin_Questionnaire_Editor_Move_UpInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_move_up = en_admin_questionnaire_editor_move_up;

/**
* | output |
* | --- |
* | "Move up" |
*
* @param {Admin_Questionnaire_Editor_Move_UpInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_move_up = /** @type {((inputs?: Admin_Questionnaire_Editor_Move_UpInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_Move_UpInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_move_up(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_move_up(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_move_up(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_move_up(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_move_up(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_move_up(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_move_up(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_move_up(inputs)
	return ro_admin_questionnaire_editor_move_up(inputs)
});
export { admin_questionnaire_editor_move_up as "admin.questionnaire_editor.move_up" }